// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resetPasswordStyles } from "@insite/content-library/Widgets/ResetPassword/ResetPassword";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

resetPasswordStyles.instructionsText = {
    as: "h4",
    variant: "h4",
};

resetPasswordStyles.passwordGridContainer = {
    gap: 24,
    css: css`
        &&& {
            max-width: 450px;
        }
    `,
};

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 5, 5, 5],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

resetPasswordStyles.requirementsGridItem = {
    width: [12, 12, 7, 7, 7],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.mainGridContainer = {
    gap: 20,
};

resetPasswordStyles.submitButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
